import React, {useEffect} from "react";
import {DeleteRounded, DescriptionRounded} from "@mui/icons-material";
import {Button, Grid, IconButton, useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useFieldArray, useForm, FormProvider} from "react-hook-form";
import {IDms, IDmsForm} from "../../models/models";
import {FormAutocomplete, FormTextField} from "../../common/form-fields-wrappers";

const AssociatedDmsList = ({list, action,  fullInfo = false}: {list: IDms[], action?: Function, fullInfo?: boolean }) => {
    const theme = useTheme();
    const {t} = useTranslation(['network', 'translation']);

    const dmsListForm = useForm<IDmsForm>({
        defaultValues: {dms: []}
    });

    const fieldArrayDmsList = useFieldArray<IDmsForm>({
        control: dmsListForm.control,
        name: "dms"
    });

    const routeChange = (idDms: any) => {
        if (!!idDms) {
            let path = `/mobility-store/dms-detail/${idDms}`;
            window.open(path, "_blank", "noreferrer");
        }
    }

    const deleteDms = (idDms: any) => {
        if (!!idDms && !!action) {
            action({action: 'delete', idDms: idDms})
        }
    }

    const updateDmsData = () => {
        if (!!action) {
            const formValues = dmsListForm.getValues();
            action({action: 'update', list: formValues.dms})
        }
    }

    useEffect(() => {
        if (!!list) {
            fieldArrayDmsList.remove();
            list
                .map((elem: any) =>
                    fieldArrayDmsList.append({
                        dmsName:                elem.dmsName,
                        dmsIdentificationCode:  elem.dmsIdentificationCode,
                        royaltiesPercentage:    elem.royaltiesPercentage ?? '',
                        emailRoyalties:         elem.emailRoyalties ?? []
                    })
                );
            dmsListForm.trigger();
        }
    }, [list]);

    return (
        <FormProvider {...dmsListForm}>
            <Grid container>
            {
                fieldArrayDmsList.fields.length > 0 &&
                list.map((dms: any, index: number) =>
                    <Grid item container xs={12} columnSpacing={2} key={`dms_detail_${index}`} sx={{my: theme.spacing(1)}}>
                        <Grid item xs={6} md={3}>
                            <FormTextField<IDmsForm>
                                name={`dms.${index}.dmsName`}
                                control={dmsListForm.control}
                                label={t("contractorMng.managerRFM.associationContractorDms.associatedDmsList.label.dmsNaming")}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <FormTextField<IDmsForm>
                                name={`dms.${index}.dmsIdentificationCode`}
                                control={dmsListForm.control}
                                label={t("contractorMng.managerRFM.associationContractorDms.associatedDmsList.label.dmsIdentifyingCode")}
                                disabled
                            />
                        </Grid>
                        {
                            fullInfo &&
                            <>
                                <Grid item xs={12} md={6}>
                                    <FormAutocomplete<IDmsForm>
                                        name={`dms.${index}.emailRoyalties`}
                                        label={t("contractorMng.managerRFM.associationContractorDms.associatedDmsList.label.emailRoyalties")}
                                        control={dmsListForm.control}
                                        fullWidth
                                        multiple
                                        freeSolo
                                        blurOnSelect={false}
                                        options={[]}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3} sx={{display: "flex"}}>
                                    <FormTextField<IDmsForm>
                                        name={`dms.${index}.royaltiesPercentage`}
                                        control={dmsListForm.control}
                                        label={t("contractorMng.managerRFM.associationContractorDms.associatedDmsList.label.percentage")}
                                    />
                                </Grid>
                            </>
                        }

                        <Grid item xs={6} md={3}
                              sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-end', pl: theme.spacing(1)}}>
                            <IconButton title={t("contractorMng.managerRFM.associationContractorDms.associatedDmsList.buttons.dmsDetails")}
                                        color="accent"
                                        onClick={() => routeChange(dms.idDms)}
                                        sx={{ml: theme.spacing(0.5)}}>
                                <DescriptionRounded/>
                            </IconButton>

                            {
                                fullInfo &&
                                <IconButton title={t("contractorMng.managerRFM.associationContractorDms.associatedDmsList.buttons.delete")}
                                            color="accent"
                                            onClick={() => deleteDms(dms.idDms)}
                                            sx={{ml: theme.spacing(0.5)}}>
                                    <DeleteRounded/>
                                </IconButton>
                            }

                        </Grid>
                    </Grid>
                )
            }

            {
                fullInfo && fieldArrayDmsList.fields.length > 0 &&
                <Grid item xs={12} sx={{display: 'flex', justifyContent: 'flex-end', mt: theme.spacing(2)}}>
                    <Button color={'accent'} onClick={updateDmsData}>
                        {t("contractorMng.managerRFM.associationContractorDms.associatedDmsList.buttons.save")}
                    </Button>
                </Grid>
            }
            </Grid>
        </FormProvider>
    );
}

export default AssociatedDmsList;